




































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { FilterService } from '@/modules/common/filter/services/filter.service'
import { Filter, FilterTypes } from '@/modules/common/filter/filter'

@Component
export default class FilterWrapper extends Vue {
  @Prop() filterService!: FilterService

  @Prop({
    required: true
  }) filters!: Filter[]

  isCustomFilter(item) {
    return item.type === FilterTypes.Custom
  }

  removeFilter(item: Filter) {
    if (item.key) {
      this.filterService.remove(item.key)
    } else if (item.keys) {
      this.filterService.remove(item.keys.from)
      this.filterService.remove(item.keys.to)
    }
  }

  hasFilter(item: Filter) {
    return item.key
      ? this.filterService.has(item.key)
      : item.keys
        ? this.filterService.has(item.keys.from) || this.filterService.has(item.keys.to)
        : false
  }
}
